import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../helpers/utils/auth.util";



const SignedInRoute = ({ children }) => {
  const token = getToken();

  const isAuthenticated = !!token
  if (isAuthenticated) return <Navigate to="/" />;

  return (
    <>
      {children}
   </>
  );
};

export default SignedInRoute;
